// extracted by mini-css-extract-plugin
export default {"header":"ModalLauncher_header__AjQuX","close":"ModalLauncher_close__4816Z","wide":"ModalLauncher_wide__NrgHL"};